import React, { Component } from 'react'
import { connect } from 'react-redux'

import { getFeatureFlag } from '../../../ducks/featureFlags'
import {
  getOrganizations,
  updateOrganization,
  fetchOrganizations,
  getCurrentOrganization,
} from '../../../ducks/organizations'

import WrappedSelect from '../../Shared/Forms/WrappedSelect'
import EmptyState from '../../Shared/EmptyState'
import Loading from '../../Shared/Loading'
import TeamNameForm from './TeamName'
import Members from './Members'
import TrialWarning from '../../Shared/TrialWarning'

class TeamSettingsSub extends Component {
  handleChangeName = async ({ name }) => {
    const { organization, updateOrganization } = this.props

    await updateOrganization(organization.id, { name })
  }

  render() {
    const { organization, onReload, hasTeamSwitcher } = this.props

    return (
      <div className="team-settings-sub">
        {hasTeamSwitcher && <h3 className="settings-header">Team Members</h3>}
        {!hasTeamSwitcher && (
          <TeamNameForm
            form={`teamName-${organization.id}`}
            onSubmit={this.handleChangeName}
            initialValues={{ name: organization.name }}
            disabled={!organization.OrganizationUser.isAdmin}
          />
        )}
        <Members
          organization={organization}
          currentUserId={organization.OrganizationUser.UserId}
          onInvite={onReload}
          onReload={onReload}
          hasTeamSwitcher={hasTeamSwitcher}
        />
        {!hasTeamSwitcher && (
          <TrialWarning
            organizationId={organization.id}
            onSuccess={onReload}
            billing
          />
        )}
      </div>
    )
  }
}

class TeamSettings extends Component {
  state = {
    selectedOrganization: null,
  }

  getOrganization = () => {
    let { organizations } = this.props
    const { selectedOrganization } = this.state

    if (organizations.length > 1) {
      organizations = organizations.filter(org => {
        return org.id === selectedOrganization
      })
    }

    return organizations[0]
  }

  handleChangeOrg = selectedOrganization => {
    this.setState({ selectedOrganization })
  }

  getOrganizationOptions = () => {
    const { organizations } = this.props

    return organizations.map(org => ({
      label: org.name,
      value: org.id,
    }))
  }

  fetchData = () => {
    const { fetchOrganizations } = this.props

    fetchOrganizations()
  }

  componentDidMount() {
    this.fetchData()
  }

  render() {
    const { selectedOrganization } = this.state

    const {
      organizations,
      currentOrganization,
      updateOrganization,
      hasTeamSwitcher,
    } = this.props

    const org = hasTeamSwitcher ? currentOrganization : this.getOrganization()

    return (
      <div className="team-settings">
        {!hasTeamSwitcher && organizations.length > 1 ? (
          <div className="team-select-menu">
            <WrappedSelect
              autoSelect
              options={this.getOrganizationOptions()}
              value={selectedOrganization}
              onChange={this.handleChangeOrg}
            />
          </div>
        ) : null}
        {org ? (
          [
            <TeamSettingsSub
              key={org.id}
              organization={org}
              updateOrganization={updateOrganization}
              onReload={this.fetchData}
              hasTeamSwitcher={hasTeamSwitcher}
            />,
          ]
        ) : (
          <EmptyState>
            <Loading />
          </EmptyState>
        )}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  organizations: getOrganizations(state),
  currentOrganization: getCurrentOrganization(state),
  hasTeamSwitcher: getFeatureFlag(state, 'hasTeamSwitcher'),
})

export default connect(mapStateToProps, {
  updateOrganization,
  fetchOrganizations,
})(TeamSettings)
